import * as React from "react"
import { Formik, Field } from "formik"
import { Alert, Button } from "reactstrap"
import ErrorMessage from "./ErrorMessage"
import { I18n } from "react-redux-i18n"
import { Link } from "react-router-dom"
import { isValidPassword, lang } from "utils/helpers"

import ALLOWED_DOMAINS from "constants/allowed-domains"
import Nixi1Spinner from "components/Nixi1Spinner"

const StepOne = (props) => {
  const { actionRegister, errorGeneral } = props
  const MAP_FIELD_ERRORS = {
    name: I18n.t("form_input_name_error"),
    lastname: I18n.t("form_input_lastname_error"),
    email: I18n.t("form_input_invalid_email"),
    password: I18n.t("form_input_password_error"),
    terms: I18n.t("form_input_tc_error"),
  }

  const MAP_FIELD_ERRORS_PASSWORD = {
    error_string: I18n.t("form_input_password_error_number_string"),
    error_space: I18n.t("form_input_password_error_space"),
    error_min_length: I18n.t("form_input_password_error_min_length"),
  }

  const initialValues = props.initialValues
  //const [errors, setErrors] = React.useState({})
  const [validateStatus, setValidateStatus] = React.useState(false)

  const validateFields = (values) => {
    const errors = {}
    if (values.name === "") {
      errors.name = MAP_FIELD_ERRORS.name
    }
    if (values.lastname === "") {
      errors.lastname = MAP_FIELD_ERRORS.lastname
    }
    if (
      actionRegister === "owner" &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
    ) {
      errors.email = MAP_FIELD_ERRORS.email
    }

    const checkValidPassword = isValidPassword(values.password)

    if (checkValidPassword.length > 0) {
      errors.password = checkValidPassword
    }

    if (values.terms !== true) {
      errors.terms = MAP_FIELD_ERRORS.terms
    }
    if (!validateStatus) {
      setValidateStatus(true)
    }
    return errors
  }

  const submitFields = (values) => {
    props.goToStepTwo(values)
  }

  React.useEffect(() => {
    const errors = {}
    for (const key in props.httpErrors) {
      errors[key] = MAP_FIELD_ERRORS[key]
    }

    //setErrors(errors)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.httpErrors])

  return (
    <Formik
      initialValues={initialValues}
      validate={validateFields}
      onSubmit={submitFields}
      validateOnChange={validateStatus}
    >
      {({ values, handleChange, handleSubmit, errors }) => (
        <div className="form-window">
          <div className="header">
            <div className="title">{I18n.t("signup_step_one_form_title")}</div>
            {/* <div className="subtitle">
              {I18n.t("signup_step_one_form_subtitle")}
            </div> */}
          </div>

          {errorGeneral && (
            <div className="signup-operator-alert-token">
              <Alert color="danger">{I18n.t("signup_generic_error")}</Alert>
            </div>
          )}

          <div
            className={`form ${
              actionRegister === "operator" ? "form-operator" : ""
            }`}
          >
            <form onSubmit={handleSubmit} className="w-100">
              <div className="personal-container">
                <div className="personal-form">
                  <label htmlFor="name">{I18n.t("dashboard_name")}<span className="required">*</span></label>
                  <input
                    className="name"
                    type="string"
                    name="name"
                    id="name"
                    onChange={handleChange}
                    value={values.name}
                    required
                  />
                  {!props.isMobile && errors.name ? (
                    <ErrorMessage text={errors.name} />
                  ) : null}
                </div>
                {props.isMobile && errors.name ? (
                  <ErrorMessage text={errors.name} />
                ) : null}
                <div className="personal-form">
                  <label htmlFor="lastname">{I18n.t("signup_step_one_form_placeholder_lastName")}<span className="required">*</span></label>
                  <input
                    className="surname"
                    type="string"
                    name="lastname"
                    id="lastname"
                    onChange={handleChange}
                    value={values.lastname}
                    required
                  />
                  {!props.isMobile && errors.lastname ? (
                    <ErrorMessage text={errors.lastname} />
                  ) : null}
                </div>
                {props.isMobile && errors.lastname ? (
                  <ErrorMessage text={errors.lastname} />
                ) : null}
              </div>
              <div className="login-container">
                {actionRegister === "owner" && (
                  <div className="login-form">
                    <label htmlFor="email">{I18n.t("signup_step_one_form_placeholder_email")}<span className="required">*</span></label>
                    <input
                      className="email"
                      type="email"
                      name="email"
                      id="email"
                      onChange={handleChange}
                      value={values.email}
                      required
                    />
                    {errors.email ? <ErrorMessage text={errors.email} /> : null}
                  </div>
                )}
                <div className="login-form">
                  <label htmlFor="password">{I18n.t("dashboard_password")}<span className="required">*</span></label>
                  <input
                    className="password"
                    type="password"
                    name="password"
                    id="password"
                    onChange={handleChange}
                    value={values.password}
                    required
                  />
                  {errors.password
                    ? errors.password.map((el) => (
                      <ErrorMessage
                        key={el}
                        text={MAP_FIELD_ERRORS_PASSWORD[el]}
                      />
                    ))
                    : null}
                </div>
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="terms-container">
              <Field
                type="checkbox"
                name="terms"
                id="terms"
                checked={values.terms}
                className="hidden-checkbox"
                value="terms"
              />
              <label htmlFor="terms" className="terms-checkbox"></label>
              <p
                dangerouslySetInnerHTML={{
                  __html: lang("dashboard_i-agree-terms-and-conditions", {
                    href: ALLOWED_DOMAINS.termsAndConditions,
                  }),
                }}
              />
            </div>
            {errors.terms ? <ErrorMessage text={errors.terms} /> : null}
            <Button
              disabled={props.loadingForm}
              className="submit-button"
              onClick={handleSubmit}
            >
              {props.loadingForm ? (
                <Nixi1Spinner height="1rem" width="1rem" />
              ) : actionRegister === "operator" ? (
                <div>{I18n.t("signup_step_one_form_button_operator")}</div>
              ) : (
                <div>{I18n.t("dashboard_continue")}</div>
              )}
            </Button>
            <div className="login-text">
              {`${I18n.t("signup_step_one_form_login_title")} `}
              <Link className="link-return" to="/login">
                {I18n.t("signup_step_one_form_login_action")}
              </Link>
            </div>
          </div>
        </div>
      )}
    </Formik>
  )
}

export default StepOne
